<template src="./vehiclecheckviewdata.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import DeleteImage from "@/pages/operations/deleteimage/deleteimage";
  var moment = require("moment");

  export default {
    components: { DeleteImage },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      removenlbr: function (data) {
        const result = data.replaceAll(/(?:\\[rn])+/g, "");
        return result;
      },
    },
    props: ["VehicleCheckSubmitId", "type"],
    data() {
      return {
        ShowLoader: false,
        VehicleChecks: [],
        CompanyChecks: [],
        TrailerChecks: "",
        CompanyLogo: "",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        biglightgallery: [],
        trailerbiglightgallery: [],
      };
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Vehicle ||
          !AccountPermissions["Vehicle Checks"] ||
          !AccountPermissions["Vehicle Checks"]["enable"])
      ) {
        this.$router.push("/");
      }
      document.title = pbx_SiteTitle + " - Vehicles Check View";
      setTimeout(() => {
        this.GetVehicleChecksList();
      }, 800);

      var Company = JSON.parse(localStorage.getItem("Company"));
      this.CompanyLogo = Company.logo;
    },
    methods: {
      LoadProfileData() {
        this.GetVehicleChecksList();
      },
      SearchVehicle() {
        this.GetVehicleChecksList();
      },
      GeneratePDF() {
        $("#save_pdf_btn").html("Processing...");
        this.$root.$emit("GeneratePDF");
      },
      GetVehicleChecksList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        obj.vehicleCheckSubmitId = this.VehicleCheckSubmitId;
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleChecks.VehicleCheckView, obj).then(
          (Response) => {
            this.ShowLoader = false;
            if (Response.data.success) {
              this.VehicleChecks = Response.data.FleetCheckSubmit;
              this.CompanyChecks = Response.data.CompanyChecks;
              this.VehicleChecks.value.forEach((element) => {
                if (Array.isArray(element.photo) && element.photo.length > 0) {
                  element.photo.forEach((photo) => {
                    this.biglightgallery.push(this.ImageEndpoint + photo);
                  });
                }
              });

              this.TrailerChecks = Response.data.FleetTrailerCheckSubmit;

              this.TrailerChecks.value.forEach((element) => {
                if (Array.isArray(element.photo) && element.photo.length > 0) {
                  element.photo.forEach((photo) => {
                    this.trailerbiglightgallery.push(
                      this.ImageEndpoint + photo
                    );
                  });
                }
              });
            } else {
              this.$router.push("/error-404");
            }
          }
        );
      },
    },
  };
</script>
<style scoped>
  .position-relative {
    position: relative;
  }
  .logomain {
    max-width: 50%;
  }
</style>
